module.exports = __webpack_public_path__ + "img/photo11.3a578c1b.jpg";